<div class="header-card card" [ngClass]="generalClass">
    <div class="partfixa incard">
        <ng-container *ngIf="booking && booking.bookingId">
            <div class="line bookingNumber">{{ booking.bookingNumber }}</div>
            <div class="line shipName">{{ booking.shipName }}</div>
            <shared-tags-strip-component class="line tagsbottom tags no-margin-between" [tags]="booking.userTags">
            </shared-tags-strip-component>
            <div class="line dates">
                <div class="line"><span class="prompt">{{ 'BOOKINGPAGE.DEPOSIT.LABEL' | translate }}</span> {{
                    booking.depositStart |
                    datahoradetalldiasetmana
                    }} -
                    {{ booking.depositEnd | datahoradetalldiasetmana }}</div>
                <div class="line"><span class="prompt">{{ 'BOOKINGPAGE.TRIP.LABEL' | translate }}</span> {{
                    booking.datetimeStart |
                    datahoradetalldiasetmana }}
                    -
                    {{ booking.datetimeEnd | datahoradetalldiasetmana }}</div>
            </div>
            <div class="bookingId">{{booking.bookingId}}</div>
        </ng-container>
        <ng-container *ngIf="!booking || !booking.bookingId">
            <span class="no-data">{{'BOOKINGPAGE.NOBOOKING' | translate}}</span>
        </ng-container>
    </div>
    <shared-booking-strip [booking]="booking"></shared-booking-strip>
</div>